import { createSelector } from "reselect"
import { initialState } from "./reducer"
import { create } from "lodash"

/**
 * Direct selector to the reportHome state domain
 */

const selectReportAmbassadorDomain = (state) =>
  state.get("reportAmbassador", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectIsMeasureProcess = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("isMeasureProcess")
  )

export const makeSelectDimensionsBottom = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("dimensionsBottom")
  )

export const makeSelectDimensionsTop = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("dimensionsTop")
  )

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("divisionsAvailable")
  )

export const makeSelectDivisionsData = () => createSelector(selectReportAmbassadorDomain, (state) => state.get("divisionsData"))

export const makeSelectMeasureGeneral = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("measureGeneral")
  )

export const makeSelectMeasureTotal = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("measureTotal")
  )

export const makeSelectIsErrorStatus = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("isErrorStatus")
  )

export const makeSelectMeasureColorRange = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectTypeMeasurement = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("typeMeasurement")
  )

export const makeSelectIsLoadingTab = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("isLoadingTab")
  )

export const makeSelectIsLoadingSubDivision = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("isLoadingSubDivision")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectReportAmbassadorDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectUserType = () =>
  createSelector(selectReportAmbassadorDomain, (state) => state.get("userType"))

const makeSelectReportAmbassador = () =>
  createSelector(selectReportAmbassadorDomain, (substate) => substate.toJS())

export default makeSelectReportAmbassador
export { selectReportAmbassadorDomain }
